import Api_Usermanagement from '../../api-usermanagement'

const api = new Api_Usermanagement().init()
const prefix = '/order-submission'

const getAccessKontrak = (id) => {
  return api.get(`/role-access/detail/${id}/171`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getAccessSo = (id) => {
  return api.get(`/role-access/detail/${id}/172`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getAccessSip = (id) => {
  return api.get(`/role-access/detail/${id}/170`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

export {getAccessKontrak, getAccessSo, getAccessSip}
